const mapStateToProps = state => 
    ({
        step: state.solicitudEmpadronamiento.step,
        data: state.solicitudEmpadronamiento.data,
        datosCiudadanoTable: state.solicitudEmpadronamiento.datosCiudadanoTable,
        cuiDPI: state.solicitudEmpadronamiento.cuiDPI,
        currentUser: state.security.currentUser,
        rechazarSolicitudExtranjero: state.solicitudEmpadronamientoExtranjero.rechazarSolicitudExtranjero,
        estadoPadronDelCiudadanoEstaEmpadronado: state.solicitudEmpadronamientoExtranjero.estadoPadronDelCiudadanoEstaEmpadronado,
        estadoPadronDelCiudadanoEstaFallecido: state.solicitudEmpadronamientoExtranjero.estadoPadronDelCiudadanoEstaFallecido
    });
export default mapStateToProps;
